import React from 'react';
import { trackInitiateCheckout } from './MetaPixel';
interface ButtonProps {
  children: React.ReactNode;
  className?: string;
  isFinal?: boolean;
  redirectUrl?: string;
}
export function Button({
  children,
  className = '',
  isFinal = false,
  redirectUrl
}: ButtonProps) {
  const handleClick = (e: React.MouseEvent) => {
    if (isFinal || redirectUrl) {
      trackInitiateCheckout();
      const url = redirectUrl || 'https://checkout.sectordigital.online/cart/44063671025707:1';
      window.location.href = url;
    } else {
      e.preventDefault();
      const target = document.getElementById('comprar');
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  };
  return <button onClick={handleClick} className={`group relative inline-flex items-center justify-center gap-2 rounded-xl bg-emerald-600 px-6 py-3.5 text-base font-bold text-white shadow-[0_4px_14px_0_rgba(5,150,105,0.39)] transition-all duration-200 hover:-translate-y-0.5 hover:bg-emerald-500 hover:shadow-[0_6px_20px_rgba(5,150,105,0.23)] active:translate-y-1 active:shadow-none sm:text-lg w-full sm:w-auto ${className}`} data-id="element-71">
      {children}
    </button>;
}